import React, { Component } from "react";
import Dialog from '@material-ui/core/Dialog';
import DialogActions from '@material-ui/core/DialogActions';
import DialogContent from '@material-ui/core/DialogContent';
import DialogTitle from '@material-ui/core/DialogTitle';
import Button from '@material-ui/core/Button';
import API from "../../actions";
import Table from '../Common/table';
import _ from "lodash";

class ListOfUsers extends Component {
    state = {
        users: [],
        dialogOpen: false,
        sortColumn: { path: "nameFirst", order: "asc" }
    }
    columns = [
        { path: "nameFirst", label: "Fornavn", type: "alpha" },
        { path: "nameLast", label: "Efternavn", type: "alpha" },
        { path: "email", label: "Email", type: "alpha" },
        { path: "phone", label: "Mobil", type: "alpha" },
    ];

    componentWillReceiveProps(nextProps) {
        if (nextProps.dialogOpen && nextProps.company.id) {
            this.setState({ users: [] });
            this.getCompanyUsers(nextProps.company.id);
        }
    }

    async getCompanyUsers(id) {
        if (id) {
            try {
                const users = await API.getCompanyTherapistsSuperadmin(id, 'createdAt', 'asc');
                this.setState({ users });
            } catch (ex) {
                console.log(ex);
            }
        }
    }

    handleSort = sortColumn => {
        this.setState({ sortColumn });
    };

    render() {
        const { users, sortColumn } = this.state;
        let sortedUsers = [];
        if (sortColumn.path === "isAvailable") {
            sortedUsers = _.orderBy(
                users,
                "isAvailable",
                [sortColumn.order]
            );
        } else {
            sortedUsers = _.orderBy(
                users,
                [user => (user[sortColumn.path] || '').toLowerCase()],
                [sortColumn.order]
            )
        }
        const { dialogOpen, onClose, company } = this.props;
        return (
            <div>
                <Dialog maxWidth="md" open={dialogOpen} aria-labelledby="form-dialog-title">
                    <form method="post" className="form-movie" onSubmit={this.handleSubmit}>

                        <DialogTitle id="form-dialog-title">List of users<br /><small>{company.companyName}</small></DialogTitle>
                        <DialogContent>
                            <div className="table-responsive">
                                <Table
                                    columns={this.columns}
                                    onSort={this.handleSort}
                                    sortColumn={sortColumn}
                                    data={sortedUsers}
                                    handleSwitchChange={this.handleSwitchChange}
                                />
                            </div>
                        </DialogContent>
                        <DialogActions>
                            <Button onClick={onClose} color="primary">Luk</Button>
                        </DialogActions>
                    </form>

                </Dialog>
            </div>
        );
    }
}

export default ListOfUsers;
